export const RECEIVE_ENTITY_DELETION = 'RECEIVE_ENTITY_DELETION';
export const RECEIVE_ENTITY = 'RECEIVE_ENTITY';
export const UPDATE_ENTITY = 'UPDATE_ENTITY';
export const REQUEST_ENTITIES = 'REQUEST_ENTITIES';
